import { useMemo } from 'react';

import { useMarketDataStatistics } from '@talos/kyoko';

import { getChancePct } from './predictionMath';

/**
 * Last-traded chance % for one outcome, taken from Market Data Statistics.
 *
 * Markets scope matches MDS snapshots: selected market accounts from the card.
 */
export function usePredictionOutcomeChance(
  symbol: string | undefined,
  subscriptionTag: string,
  options: { marketAccounts?: string[] }
): number | undefined {
  const markets = useMemo(() => [...(options.marketAccounts ?? [])], [options.marketAccounts]);
  const { marketDataStatistics } = useMarketDataStatistics(symbol ?? '', markets, subscriptionTag);

  return useMemo(() => {
    // Statistics for the previous symbol keep emitting until the new subscription responds, so
    // ignore any that no longer belong to this outcome.
    if (!symbol || marketDataStatistics?.Symbol !== symbol) {
      return undefined;
    }
    return getChancePct(marketDataStatistics.LastPrice);
  }, [marketDataStatistics, symbol]);
}
